export default __webpack_public_path__ + "static/media/0.eb8b1cff.svg";